function IconBusinessClient({ fillColor = "none", strokeColor = "currentColor" }) {
  return (
    <svg width="59" height="58" viewBox="0 0 59 58" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_113_1782)">
        <path d="M40.8946 19.105C40.8946 25.5406 35.6876 30.7476 29.252 30.7476C22.8164 30.7476 17.6094 25.5406 17.6094 19.105C17.6094 12.6694 22.8164 7.4624 29.252 7.4624C35.6876 7.4624 40.8946 12.6694 40.8946 19.105Z" stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M9.46484 50.5376C9.46484 39.6116 18.3284 30.748 29.2544 30.748C40.1803 30.748 49.0439 39.6116 49.0439 50.5376" stroke={strokeColor} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_113_1782">
          <rect width="42.4897" height="46" fill={fillColor} transform="translate(8 6)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconBusinessClient;